export default defineAppConfig({
  ui: {
    modal: {
      slots: {
        overlay: 'bg-black/60',
        content: 'bg-modal text-title',
      },
    },
    button: {
      compoundVariants: [
        // Primary Solid Button
        {
          color: 'primary',
          variant: 'solid',
          class:
            'bg-primary-500 text-white hover:bg-primary-600 disabled:bg-gray-200 disabled:text-gray-400 dark:bg-primary-600 dark:text-gray-50 dark:hover:bg-primary-700 dark:disabled:bg-gray-700 dark:disabled:text-gray-400',
        },
        // Primary Outline Button
        // Default white / primary-500 / primary-500
        // Hover primary-500  /white / primary-500
        // Disabled white / gray-200 / gray-200
        {
          color: 'primary',
          variant: 'outline',
          class:
            'bg-white text-primary-500 ring-primary-500 hover:bg-primary-500 hover:text-white disabled:bg-white disabled:text-gray-200 disabled:ring-gray-200 dark:bg-gray-700 dark:text-primary-600 dark:ring-primary-600 dark:hover:bg-primary-600 dark:hover:text-gray-50 dark:disabled:bg-gray-700 dark:disabled:text-gray-400 dark:disabled:ring-gray-600',
        },
        // Neutral Solid Button
        {
          color: 'neutral',
          variant: 'solid',
          class:
            'bg-gray-800 text-white hover:bg-gray-700 disabled:bg-gray-200 disabled:text-gray-400 dark:bg-gray-100 dark:text-black dark:hover:bg-gray-600 dark:disabled:bg-gray-800 dark:disabled:text-gray-400',
        },
        // Neutral Outline Button
        {
          color: 'neutral',
          variant: 'outline',
          class:
            'bg-white text-gray-800 ring-gray-200 hover:bg-gray-200 disabled:bg-white disabled:text-gray-200 disabled:ring-gray-200 dark:bg-gray-700 dark:text-gray-50 dark:ring-gray-600 dark:hover:bg-gray-600 dark:disabled:bg-gray-800 dark:disabled:text-gray-400 dark:disabled:ring-gray-700',
        },
        // Neutral Ghost Button
        {
          color: 'neutral',
          variant: 'ghost',
          class:
            'bg-transparent text-gray-800 hover:bg-gray-200 disabled:text-gray-400 dark:text-gray-50 dark:hover:bg-gray-700 dark:disabled:text-gray-600',
        },
        // Secondary Solid Button
        {
          color: 'secondary',
          variant: 'solid',
          class:
            'bg-secondary-500 text-white hover:bg-secondary-600 disabled:bg-gray-200 disabled:text-gray-400 dark:bg-secondary-500 dark:text-gray-50 dark:hover:bg-secondary-600 dark:disabled:bg-gray-700 dark:disabled:text-gray-400',
        },
        // Error Solid Button
        {
          color: 'error',
          variant: 'solid',
          class:
            'bg-error-100 text-white hover:bg-error-300 disabled:bg-error-50 disabled:text-white dark:bg-error-500 dark:text-gray-50 dark:hover:bg-error-600 dark:disabled:bg-gray-700 dark:disabled:text-gray-400',
        },
      ],
    },
    input: {
      compoundVariants: [
        {
          class:
            'bg-white text-gray-800 ring-gray-400 dark:bg-gray-900 dark:text-gray-300 dark:ring-gray-700 focus:ring-primary-500 dark:focus:ring-primary-600 disabled:bg-gray-50 disabled:text-gray-200 disabled:ring-gray-200 dark:disabled:bg-gray-800 dark:disabled:text-gray-400 dark:disabled:ring-gray-700',
        },
      ],
    },
    textarea: {
      compoundVariants: [
        {
          class:
            'bg-white text-gray-800 ring-gray-400 dark:bg-gray-900 dark:text-gray-300 dark:ring-gray-700 focus:ring-primary-500 dark:focus:ring-primary-600 disabled:bg-gray-50 disabled:text-gray-200 disabled:ring-gray-200 dark:disabled:bg-gray-800 dark:disabled:text-gray-400 dark:disabled:ring-gray-700',
        },
      ],
    },
    formField: {
      slots: {
        label: 'text-title',
        description: 'text-body',
      },
    },
    card: {
      slots: {
        body: 'bg-card rounded-lg text-title',
        footer: 'bg-card rounded-b-lg',
      },
    },
    switch: {
      slots: {
        base: 'data-[state=unchecked]:bg-gray-400 data-[state=unchecked]:dark:bg-accented',
        thumb: 'bg-white',
      },
    },
    badge: {
      compoundVariants: [
        {
          color: 'neutral',
          variant: 'soft',
          class: 'bg-gray-500 text-white',
        },
      ],
    },
    dropdownMenu: {
      slots: {
        item: 'items-center',
      },
    },
  },
});
